import axios from "axios";


export default {
    getAllUsers(){
        return axios.get("/a1/user/all")
    }
}